import React, { useState, useEffect } from "react";
import api from "../../../services/api.js";

const EnableDisablePppModal = ({ isOpen, onClose, row, onSuccess }) => {
  const [adminNote, setAdminNote] = useState("");
  const [yesOrNo, setYesOrNo] = useState("no");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (row) {
      setYesOrNo(row.disabled ? "no" : "yes");
      setAdminNote("");
      setError(null);
    }
  }, [row]);

  if (!isOpen || !row) return null;

  const handleSubmit = async () => {
    try {
      setLoading(true);
      setError(null);

      await api.post(
        "/enabled-disabled-user-ppp",
        {
          mikrotik_id: row.mikrotik_id,
          yes_or_no: yesOrNo,
          admin_note: adminNote,
        },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      );

      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || "Gagal memproses data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="w-full max-w-md rounded-lg bg-white dark:bg-slate-900 shadow-lg">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b dark:border-slate-700">
          <h2 className="text-sm font-semibold">
            {row.disabled ? "Enable PPP User" : "Disable PPP User"}
          </h2>
          <button onClick={onClose}>✕</button>
        </div>

        {/* Content */}
        <div className="px-4 py-4 space-y-3 text-sm">
          <div>
            <p className="text-gray-500">PPP Name</p>
            <p className="font-medium">{row.name}</p>
          </div>

          <div>
            <p className="text-gray-500">Customer ID</p>
            <p>{row.customer_id || "-"}</p>
          </div>

          <div>
            <p className="text-gray-500">Current Status</p>
            <p className={row.disabled ? "text-red-500" : "text-green-500"}>
              {row.disabled ? "Disabled" : "Enabled"}
            </p>
          </div>

          <div>
            <label className="block mb-1 text-gray-500">Action</label>
            <select
              value={yesOrNo}
              onChange={(e) => setYesOrNo(e.target.value)}
              className="w-full rounded border px-3 py-2 text-sm
               dark:bg-slate-800 dark:border-slate-700"
            >
              <option value="no">Enable</option>
              <option value="yes">Disable</option>
            </select>
          </div>

          <div>
            <label className="block mb-1 text-gray-500">Admin Note</label>
            <textarea
              rows={3}
              value={adminNote}
              onChange={(e) => setAdminNote(e.target.value)}
              className="w-full rounded border px-3 py-2 text-sm
               dark:bg-slate-800 dark:border-slate-700"
            />
          </div>

          {error && <p className="text-xs text-red-500">{error}</p>}
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 px-4 py-3 border-t dark:border-slate-700">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-xs rounded border
                       dark:border-slate-600"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className={`px-3 py-1.5 text-xs rounded text-white ${
              row.disabled ? "bg-green-600" : "bg-red-600"
            }`}
          >
            {loading
              ? "Processing..."
              : row.disabled
              ? "Enable User"
              : "Disable User"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnableDisablePppModal;
